import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-4"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Application
          </Link>
          
          <div className="flex items-center mb-4">
            <Shield className="h-8 w-8 text-blue-600 mr-3" />
            <h1 className="text-3xl font-bold text-gray-900">Terms of Service</h1>
          </div>
          
          <p className="text-gray-600">
            Last Updated: {new Date().toLocaleDateString()}
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="prose max-w-none">
            
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 mb-4">
              By accessing and using our loan application service ("Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this Service.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">2. Service Description</h2>
            <p className="text-gray-700 mb-4">
              Our Service is a lead generation platform that connects potential borrowers with lending partners. We do not make loans ourselves but facilitate connections between applicants and licensed lenders.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">3. Eligibility Requirements</h2>
            <p className="text-gray-700 mb-2">To use our Service, you must:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Be at least 18 years of age</li>
              <li>Be a legal resident of the United States</li>
              <li>Have a valid Social Security number</li>
              <li>Have a regular source of income</li>
              <li>Have an active checking account</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">4. Information Sharing</h2>
            <p className="text-gray-700 mb-4">
              By submitting your application, you authorize us to share your information with our network of lending partners. This information may include personal, financial, and employment details necessary for loan evaluation.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">5. Communication Consent</h2>
            <p className="text-gray-700 mb-4">
              You consent to receive communications from us and our lending partners via phone, email, text message, or mail regarding loan products and services. You understand that consent is not required to obtain a loan.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">6. No Guarantee of Approval</h2>
            <p className="text-gray-700 mb-4">
              Submission of an application does not guarantee loan approval. All lending decisions are made by individual lenders based on their own criteria and underwriting guidelines.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">7. Fees and Costs</h2>
            <p className="text-gray-700 mb-4">
              Our Service is free to consumers. We may receive compensation from lending partners for successful matches. Any fees associated with loans are determined by and paid to the individual lenders.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">8. Privacy and Security</h2>
            <p className="text-gray-700 mb-4">
              We take your privacy seriously and employ industry-standard security measures to protect your information. Please review our Privacy Policy for detailed information about how we collect, use, and protect your data.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">9. Prohibited Uses</h2>
            <p className="text-gray-700 mb-2">You may not use our Service to:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Submit false or misleading information</li>
              <li>Apply for loans you have no intention of accepting</li>
              <li>Use automated systems to submit applications</li>
              <li>Interfere with the operation of our Service</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">10. Disclaimers</h2>
            <p className="text-gray-700 mb-4">
              Our Service is provided "as is" without warranties of any kind. We disclaim all warranties, express or implied, including warranties of merchantability and fitness for a particular purpose.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">11. Limitation of Liability</h2>
            <p className="text-gray-700 mb-4">
              We shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of our Service.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">12. Changes to Terms</h2>
            <p className="text-gray-700 mb-4">
              We reserve the right to modify these terms at any time. Changes will be posted on this page with an updated revision date.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">13. Contact Information</h2>
            <p className="text-gray-700 mb-4">
              If you have questions about these Terms of Service, please contact us at:
            </p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700">
                Email: <a href="mailto:support@lendsnap.com" className="text-blue-600 hover:text-blue-800">support@lendsnap.com</a><br />
                Address: [Your Business Address]<br />
                Phone: [Your Business Phone]
              </p>
            </div>

          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center">
          <Link 
            to="/" 
            className="inline-flex items-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
          >
            Return to Application
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 